import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'
import LPContainer from './LPContainer'
import { TypographyText } from '~/core/ui/Text'

const SkillFoundationSection: FCC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('allFeature:skill_foundation:section_1_content_title'),
      contentDescription: t(
        'allFeature:skill_foundation:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/talent-intelligence-skill01.png',
      direction: 'ltr',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:skill_foundation:section_2_content_title'),
      contentDescription: t(
        'allFeature:skill_foundation:section_2_content_description'
      ),
      contentImage: '/img/feature/lp/new/talent-intelligence-skill02.png',
      direction: 'rtl',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="allFeature:skill_foundation:title"
      description="allFeature:skill_foundation:description"
      tagLabel="allFeature:skill_foundation:tag"
      tagColor="bg-purple-100 text-purple-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[140px]')}>
      <LPContainer className="mt-10 space-y-10 px-0 tablet:px-4">
        {SECTIONS.map((item, index) => {
          return (
            <div
              key={index}
              className={cn(
                'items-center flex flex-col tablet:flex-row',
                item.direction === 'ltr' ? '' : 'tablet:flex-row-reverse'
              )}>
              <div
                className={cn(
                  'flex-1 mb-20 tablet:mb-0',
                  item.direction === 'ltr' ? 'tablet:mr-20' : 'tablet:ml-20'
                )}>
                <TypographyText className="text-[23px] font-medium text-gray-900">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="text-base font-normal text-gray-700 mt-3">
                  {item.contentDescription}
                </TypographyText>
              </div>

              <div className="bg-gray-100">
                <img
                  src={item.contentImage}
                  alt={`screenshot ${index}`}
                  className="tablet:max-w-[495px] max-w-full"
                />
              </div>
            </div>
          )
        })}
      </LPContainer>
    </SectionContainer>
  )
}

export default SkillFoundationSection
